<script lang="ts" generics="ITEM">
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchSorting from '../kp-search-sorting/KpSearchSorting.svelte';
    import KpSearchPageSize from '../kp-search-page-size/KpSearchPageSize.svelte';
    import KpAvailableIntentsContainer from '../kp-available-intents/KpAvailableIntentsContainer.svelte';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';
    import KpPageableSearchResults from '../kp-search-results/KpPageableSearchResults.svelte';
    import KpResolvableSearchResultsDisplayer from '../kp-resolvable-search-results-displayer/KpResolvableSearchResultsDisplayer.svelte';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();
</script>

<div class="search-page-size-and-sorting">
    <KpSearchSorting {searchManager}/>

    <KpSearchPageSize {searchManager}/>
</div>

{#if exists($lastSearch)}
    <KpHorizontalSeparator marginVertical="12px"/>
{/if}

<KpPageableSearchResults pagination="{searchManager.getPagination()}"
                         showPageButtons="{exists($lastSearch) && exists($lastSearch.features) && $lastSearch.features.includes('randomPageAccessing')}"
                         loadingSize="lg"
                         let:paginationData>
    <KpResolvableSearchResultsDisplayer {searchManager} {paginationData}/>
</KpPageableSearchResults>

<KpAvailableIntentsContainer {searchManager}/>

<style lang="less">
    .search-page-size-and-sorting {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
    }
</style>